import Config from '@config';
import { initializeAddressesApi } from '@gasbi/shared';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

const addressesApiObject = initializeAddressesApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});

export const {
  addressesApi,
  useGetBuildingNumbersQuery,
  useGetSettlementsIInfiniteQuery,
  useGetStreetIInfiniteQuery,
} = addressesApiObject;
